import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  ModeOfTransport,
  TransitGoodsItem,
  TransitPhase,
  TransitSummary
} from "@portbase/bezoekschip-service-typescriptmodels";
import {lodash} from "../../common/utils";
import {PortvisitUtils} from "../../refdata/portvisit-utils";

@Component({
    selector: 'app-transit-summary',
    templateUrl: './transit-summary.component.html',
    styleUrls: ['./transit-summary.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransitSummaryComponent {
  @Input() keepTooltipOpen: boolean;
  model: TransitSummary;
  refData = PortvisitUtils;
  accepted = TransitPhase.accepted;
  NOT_SPECIFIED = ModeOfTransport.NOT_SPECIFIED;

  packageCount = () => 0;
  weight = () => 0;
  phase = (): string => null;
  phaseType = (): 'danger' | 'warning' | 'info' | 'success' | 'secondary' | 'dark' | 'light' => null;

  @Input() set setModel(model: TransitSummary) {
    this.model = model;
    this.phase = () => {
      switch (model.phase) {
        case TransitPhase.declared:
          return 'scheduled';
        case TransitPhase.cancelled:
          return model.cancelInitiatedByCustoms ? 'cancelled by customs' : 'cancel accepted';
        case TransitPhase.undeclared:
          return 'draft';
        case TransitPhase.inTransitMrnAccepted:
          return 'In Transit MRN Accepted';
        case TransitPhase.inTransitMrnRejected:
          return 'In Transit MRN Rejected';
        case TransitPhase.inTransitMrnSent:
          return 'In Transit MRN Sent';
      }
      return model.phase;
    };
    this.phaseType = () => {
      switch (model.phase) {
        case TransitPhase.discrepancies:
        case TransitPhase.inTransitMrnRejected:
        case TransitPhase.incident:
        case TransitPhase.rejected:
        case TransitPhase.releaseRejected:
          return 'danger';
        case TransitPhase.inspection:
        case TransitPhase.insufficientGuarantee:
        case TransitPhase.proofOfArrivalRequested:
          return 'warning';
        case TransitPhase.inTransitMrnSent:
        case TransitPhase.sent:
        case TransitPhase.cancellationRequested:
          return 'info';
        case TransitPhase.accepted:
          return model.departureModeOfTransport === ModeOfTransport.NOT_SPECIFIED ? 'warning' : 'success';
        case TransitPhase.inTransit:
        case TransitPhase.inTransitMrnAccepted:
        case TransitPhase.proofOfArrivalSent:
        case TransitPhase.arrived:
        case TransitPhase.writtenOff:
          return 'success';
        case TransitPhase.declared:
          return 'dark';
        case TransitPhase.undeclared:
          return 'light';
        case TransitPhase.cancelled:
          return 'secondary';
      }
    };
  }

  @Input() set item(item: TransitGoodsItem) {
    this.items = [item];
  }

  @Input() set items(items: TransitGoodsItem[]) {
    this.weight = () => lodash.sumBy(items, g => g.weight || 0);
    this.packageCount = () => lodash.sumBy(items, g => g.numberOfPackages);
  }
}
